<template>
<div>

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />

    <h1 class="title">{{ texts.email }}</h1>

    <div class="page-form">

        <b-field
            :label="`${texts.email} (*)`"
        >
            <b-input
                v-model="form.email"
                :placeholder="texts.email"
            />
        </b-field>

        <b-field
            :label="`${texts.attachments}`"
        >
            <b-upload v-model="form.attachedFiles"
                multiple
                drag-drop
            >
                <section class="section">
                    <div class="content has-text-centered">
                        <p>
                            <b-icon
                                icon="upload"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>{{ texts.dropFiles }}</p>
                    </div>
                </section>
            </b-upload>
        </b-field>

        <div class="tags">
            <span v-for="(file, index) in form.attachedFiles"
                :key="index"
                class="tag is-info"
            >
                {{file.name}}
                <button class="delete is-small"
                    type="button"
                    @click="deleteDropFile(index)">
                </button>
            </span>
        </div>

        <b-field
            :label="`${texts.comment}`"
        >
            <b-input
                type="textarea"
                maxlength="255"
                v-model="form.comment"
                :placeholder="texts.typeComment"
            />
        </b-field>

    </div>

    <div class="actions">
        <button class="button is-warning actions-btn" @click="back()">
            <b-icon
                pack="fas"
                icon="undo-alt">
            </b-icon>
        </button>
        <button class="button is-info actions-btn" @click="sendEmail()">
            <b-icon
                pack="fas"
                icon="envelope">
            </b-icon>
        </button>
    </div>

</div>
</template>

<script>
import moment from 'moment';
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

export default {
    name: 'Email',
    mixins: [ Utils ],
    data () {
        return {
            isLoading: false,
            config: {},
            texts: {},
            session: null,
            sessionData: null,
            form: {
                email: null,
                comment: null,
                attachedFiles: []
            },
            errors: {
                email: null,
            }
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        if (!HealthCareService.isLogged()) this.$router.push('/');
        this.session = this.$route.params.session;
        HealthCareService.getSession(this.session)
            .then(res => {
                this.sessionData = res.data;
                if (this.sessionData.notificationMethod === 'email') this.form.email = this.sessionData.notificationParam;
            })
            .catch(error => {
                const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
            })
    },
    methods: {
        back() {
            this.$router.push('/professional/call');
        },
        deleteDropFile(index) {
            this.form.attachedFiles.splice(index, 1)
        },
        sendEmail() {
            let formData = new FormData();
            formData.append('type', 'attachments');
            formData.append('message', this.form.comment);
            formData.append('to', this.form.email);
            for (let file in this.form.attachedFiles) {
                formData.append('files', this.form.attachedFiles[file]);
            }
            this.isLoading = true;
            HealthCareService.sendEmail(formData)
                .then(res => {
                    this.$buefy.toast.open({ message: this.texts.emailSent, type: 'is-success', position: 'is-bottom' });
                    setTimeout(() => {
                        this.isLoading = false;
                        this.$router.push('/professional/call');
                    }, 1000);
                })
                .catch(error => {
                    this.isLoading = false;
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                })
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-form {
    width: 500px;
    max-width: 90%;
    margin: 0 auto;
    text-align: left;
    margin-bottom: 20px;
}
.actions {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    .actions-btn {
        border-radius: 30px;
        height: 60px;
        width: 60px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/professional/Email.vue